import styled from 'styled-components';

interface MessageProps {
	isMobile?: boolean;
}

export const UpdateCard = styled.div<MessageProps>`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding-top: 10px;
	padding-bottom: 12px;
	padding-left: 14px;
	padding-right: 16px;
	margin-bottom: 12px;
	background-color: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	font-size: ${({ isMobile }) => (isMobile ? '16px' : '13px')};
	color: ${({ theme }) => theme.gray[800]};
	transition: background-color 0.2s ease, border-color 0.2s ease;

	cursor: default;
	user-select: none;

	&:hover {
		background-color: ${({ theme }) => theme.gray[200]};
		border-color: ${({ theme }) => theme.gray[400]};
	}

	&:active {
		background-color: ${({ theme }) => theme.gray[400]};
	}
`;

export const UpdateTitleRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const UpdateIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`;

export const UpdateTitle = styled.div`
	flex: 1;
	line-height: 1.4;
`;

export const UpdateNote = styled.div<MessageProps>`
	font-size: ${({ isMobile }) => (isMobile ? '14px' : '11px')};
	color: ${({ theme }) => theme.gray[600]};
	margin-top: 4px;
`;
